
import { Component, Watch, Ref, Prop, Vue } from 'nuxt-property-decorator';
import SimpleBar from 'simplebar';
import { GlobalDropdownEvents } from '../../types';
import Collapsible from './Collapsible.vue';

@Component({
  components: {
    Collapsible,
  },
})
export default class LangChooser extends Vue {
  @Prop({ type: String, default: 'tertiary-gray' }) readonly hierarchy!: string;
  @Prop({ type: Boolean, default: false }) readonly dark!: boolean;

  @Ref('optionsMenuContainer') readonly optionsMenuContainer?: HTMLMenuElement;
  @Ref('selectButton') readonly selectButton?: HTMLElement;

  isOpen = false;
  simplebarInstance: SimpleBar | null = null;
  scrollElement: HTMLElement | null = null;

  get locales() {
    return this.$i18n.locales;
  }

  get currentLang() {
    return this.$i18n.locale.toUpperCase();
  }

  @Watch('$route')
  onRouteChanged() {
    this.isOpen = false;
  }

  @Watch('isOpen')
  onIsOpenChange(isOpen: boolean, wasOpen: boolean) {
    if (isOpen === wasOpen) return;

    if (isOpen) {
      document.body.addEventListener('click', () => this.closeTray());
      this.$eventBus.on(GlobalDropdownEvents.Close, this.closeTray);
    } else {
      document.body.removeEventListener('click', () => this.closeTray());
      this.$eventBus.off(GlobalDropdownEvents.Close, this.closeTray);
    }
  }

  async mounted() {
    await this.$nextTick();
    if (!this.optionsMenuContainer) return;
    this.simplebarInstance = new SimpleBar(this.optionsMenuContainer);
    await this.$nextTick();
    this.optionsMenuContainer?.querySelector('[tabindex="0"]')?.removeAttribute('tabindex');
    this.scrollElement = this.simplebarInstance.getScrollElement();
  }

  beforeDestroy() {
    document.body.removeEventListener('click', () => this.closeTray());
    this.$eventBus.off(GlobalDropdownEvents.Close, this.closeTray);
  }

  public changeLanguage(code: string) {
    if (this.$i18n.locale === code) return;
    this.$moment.locale(code);
    this.$i18n.setLocaleCookie(code);
    this.$router.push(this.switchLocalePath(code));
  }

  public isLanguageActive(code: string) {
    return this.$i18n.locale === code;
  }

  public onButtonClick() {
    if (!this.isOpen) this.$eventBus.emit(GlobalDropdownEvents.Close);
    this.isOpen = !this.isOpen;
  }

  public tabTrapHandle(index: number): string | null {
    return index === 0 ? 'first' : index === this.$i18n.locales.length - 1 ? 'last' : null;
  }

  public closeTray(focusButton = false) {
    this.isOpen = false;
    if (focusButton) this.selectButton?.focus();
  }

  public onTrayClose() {
    if (!this.scrollElement) return;
    this.scrollElement.scrollTop = 0;
  }
}
